import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute }                   from '@angular/router';

import { CsvService }               from './../csv.service';
import { TimezoneService }          from './../../../shared/services/timezones.service';
import { ErrorService }             from './../../../shared/services/error.service';
import { SearchService }            from '../../../shared/services/search.service';

import { BatchCommitInfo }          from '../../../models/program/batch-commit-info';

import { ConnectableObservable }    from 'rxjs/observable/ConnectableObservable';
import { Observable }               from 'rxjs/Observable';
import { Subscription }             from 'rxjs/Subscription';
import { EditionListService }       from '../../../editions/edition.service';
import { NewAndExistingUsers } from '../../../models/program/new-and-existing-users';
import { UserWelcomeMessage } from '../../../models/program/user-welcome-message';

@Component({
  selector: 'app-subscription-settings',
  templateUrl: './subscription-settings.component.html',
  styleUrls: ['./subscription-settings.component.less']
})

export class SubscriptionSettingsComponent implements OnInit, OnDestroy {
  @Input()  commitInfoForSubscriptionSettings?:    BatchCommitInfo;
  @Input()  newAndExistingUserList?:               NewAndExistingUsers;
  @Output() reset:                                 EventEmitter<boolean> = new EventEmitter<boolean>();

  public subscriptionSettingsForm: FormGroup;
  public showNewSubscription = false;
  public sendWelcome = false;
  public saving;
  public errors;
  public subs: Subscription[] = [];
  public subscriptionOptions: {id: number, name: string}[];
  public planOptions: {id: number, name: string}[];

  constructor(
    private _fb: FormBuilder,
    private csvService: CsvService,
    private router: Router,
    public tz: TimezoneService,
    private errorService: ErrorService,
    private editionListService: EditionListService,
    private search: SearchService
  ) { }

  public ngOnInit(): void {
    this.csvService.retrieveSubscriptionAndPlanOptions()
      .subscribe(options => {
        this.planOptions = options.plan_options;
        let subscriptionOptions = options.subscription_options.map(option => {
          return {id: option.id, name: option.name + ' (id:' + option.id + ', plan: ' + option.plan + ')'}
        });
        this.subscriptionOptions = [{id: -1, name: 'New Subscription'}, ...subscriptionOptions];
      })
    let formBasic = {
      subscription_id: [-1, <any>Validators.required],
      welcome: [false, <any>Validators.required],
      new_subscription: this._fb.group({
        name: ['', <any>Validators.required],
        plan_id: [0, <any>Validators.required],
        end_date: [null],
        start_date: [this.createNowReleaseStringUTC()],
        notify_start: [false, <any>Validators.required],
      }),
    }
    if (this.commitInfoForSubscriptionSettings) {
      this.subscriptionSettingsForm = this._fb.group({
        commit_info: [this.commitInfoForSubscriptionSettings],
        ...formBasic
      })
    } else if (this.newAndExistingUserList) {
      this.subscriptionSettingsForm = this._fb.group({
        user_list: [this.newAndExistingUserList],
        ...formBasic
      })
    }
    window.setTimeout(() => {
      // setTimeout needed because of bug: https://github.com/angular/angular/issues/22556
      this.checkForNewSubscription()
      // this.subscriptionSettingsForm.controls['welcome'].disable();
    }, 0)
  }

  public ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

/**
 * Private Methods
 */

  private checkForNewSubscription() {
    if (this.subscriptionSettingsForm.controls['subscription_id'].value === -1) {
      this.subscriptionSettingsForm.controls['new_subscription'].enable();
      this.showNewSubscription = true;
    } else {
      this.subscriptionSettingsForm.controls['new_subscription'].disable();
      this.showNewSubscription = false;
    }
  }


  private resetData() {
    this.reset.emit();
  }

  private formatDateTime(int: number): string {
    let measure: string;
    if (int < 10) {
      measure = `0${int}`;
    } else {
      measure = int.toString();
    }
    return measure;
  }

  public createNowReleaseStringUTC(): string {
    let now: Date = new Date(Date.now());
    let month: string = this.formatDateTime(now.getUTCMonth() + 1);
    let day: string = this.formatDateTime(now.getUTCDate());
    let hour: string = this.formatDateTime(now.getUTCHours());
    let minutes = '00';
    let seconds = '00';
    let dateString: any = `${now.getUTCFullYear()}-${month}-${day}`;
    let timeString: any = `${hour}:${minutes}`;
    return `${dateString}T${timeString}:${seconds}`;
  }

  private commit(model: {
    subscription_id: number,
    batchCommitInfo: BatchCommitInfo,
    new_subscription?: {
      name: string,
      plan_id: number,
      end_date: any,
      start_date: [null],
      notify_start: Boolean,
    },
    welcome: Boolean
  }): void {
    this.saving = true;
    this.csvService.commitBatchAddUsersToEdition(this.editionListService.getEdition().id, model)
      .subscribe(res => {
        console.log(res);
        this.saving = false;
        this.resetData();
      }, error => {
        this.saving = false;
        this.errors = this.errorService.messages(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/subscription/subscription-settings.component.ts